import "./global.css";
import "./theme/theme.css";
import "./locales/i18n";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router";
import { installChunkLoadRecovery } from "@/utils/chunk-load-recovery";
// MSW 已禁用，所有请求直接走真实后端
// import { worker } from "./_mock";
import App from "./App";
import { registerLocalIcons } from "./components/icon";
import { GLOBAL_CONFIG } from "./global-config";
import ErrorBoundary from "./routes/components/error-boundary";
import { routesSection } from "./routes/sections";

// import { urlJoin } from "./utils";

installChunkLoadRecovery();

registerLocalIcons();

const hideBootSplash = () => {
	const splash = document.getElementById("app-boot-splash");
	if (!splash) return;

	splash.classList.add("app-boot-splash--hidden");
	window.setTimeout(() => {
		splash.remove();
	}, 220);
};
// MSW 已完全禁用，所有请求直接走真实后端
// await worker.start({
// 	onUnhandledRequest: (request, print) => {
// 		// 直接绕过 Google Cloud Storage 的请求，不经过 MSW 处理
// 		// 这样可以避免大文件上传时的性能问题（MSW 会读取整个文件到内存）
// 		if (request.url.includes("storage.googleapis.com")) {
// 			// 返回 undefined 表示完全绕过，不拦截此请求
// 			return;
// 		}
// 		// 其他未处理的请求使用 bypass（转发到真实网络）
// 		return "bypass";
// 	},
// 	serviceWorker: {
// 		url: urlJoin(GLOBAL_CONFIG.publicPath, "mockServiceWorker.js"),
// 		// 配置 Service Worker 选项
// 		options: {
// 			// 注意：MSW v2 不支持直接配置 Service Worker 绕过某些请求
// 			// 但 onUnhandledRequest 返回 undefined 应该可以绕过
// 		},
// 	},
// });

const router = createBrowserRouter(
	[
		{
			Component: () => (
				<App>
					<Outlet />
				</App>
			),
			errorElement: <ErrorBoundary />,
			children: routesSection,
		},
	],
	{
		basename: GLOBAL_CONFIG.publicPath,
	}
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<RouterProvider router={router} />);

window.requestAnimationFrame(() => {
	window.requestAnimationFrame(hideBootSplash);
});
